import { INavigationItem } from "@origin-digital/navigation-client-sdk";

export const isActiveNavSection = (href?: string): boolean => {
  const pathname = global?.window?.location?.pathname;

  if (!pathname || !href) {
    return false;
  }

  // Exact match or exact match with trailing slash
  if (pathname === href || pathname === `${href}/`) {
    return true;
  }

  // Special handling for /my/usage to support child routes like /my/usage/internet
  // This is needed because the Usage tab is at /my/usage but child pages exist
  if (href === "/my/usage" && pathname.startsWith("/my/usage/")) {
    return true;
  }

  return false;
};

export const hasChildren = (navLinkConfig: INavigationItem): boolean =>
  !!navLinkConfig.children && navLinkConfig.children.length > 0;
